import {PlanInfo, PlanList, getEventId} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {DropdownOptionProps, DropdownOptionTextOverflow} from 'wix-ui-tpa'
import {Dropdown} from 'wix-ui-tpa/cssVars'
import {FormStep} from '../../../constants'
import {useAppActions, useAppSelector} from '../../../hooks/runtime'
import {getEvent} from '../../../selectors/event'
import {
  getPlanBenefitText,
  getPurchasedPlans,
  getSelectedPaidPlan,
  planHasRemainingCredits,
} from '../../../selectors/paid-plans'
import {getReservationId} from '../../../selectors/reservation'
import {NO_MEMBERSHIP_PLAN_ORDER_ID} from '../../form/constants'
import {MembershipDropdownProps} from './interfaces'
import {classes} from './membership-dropdown.st.css'

export const MembershipDropdown = ({mobile, currentStep}: MembershipDropdownProps) => {
  const {t} = useTranslation()
  const {applyPlan, editStep} = useAppActions()

  const purchasedPlans = useAppSelector(getPurchasedPlans)
  const selectedPlan = useAppSelector(getSelectedPaidPlan)
  const eventId = getEventId(useAppSelector(getEvent))
  const reservationId = useAppSelector(getReservationId)

  const paymentStep = currentStep === FormStep.Payment

  const planOptions: PlanList = [
    {
      id: undefined,
      name: t('membership_not_selected'),
      status: undefined,
      visible: true,
      purchased: true,
      discount: undefined,
      remainingCredits: undefined,
      planOrderId: NO_MEMBERSHIP_PLAN_ORDER_ID,
      benefitId: undefined,
      plan: {},
    },
    ...purchasedPlans,
  ]

  const dropdownOptions: DropdownOptionProps[] = planOptions.map((plan: PlanInfo) => ({
    id: plan.planOrderId,
    value: plan.name,
    subtitle: plan.planOrderId === NO_MEMBERSHIP_PLAN_ORDER_ID ? undefined : getPlanBenefitText(plan, t, true),
    isSelectable: planHasRemainingCredits(plan) || plan.planOrderId === NO_MEMBERSHIP_PLAN_ORDER_ID,
    disabled: !planHasRemainingCredits(plan),
    textOverflow: DropdownOptionTextOverflow.wrap,
  }))

  const setSelectedPlan = (planOrderId: string) => {
    if (paymentStep) {
      editStep({step: FormStep.BuyerDetails, validPaymentAdded: false})
    }
    applyPlan({eventId, reservationId, planOrderId})
  }

  return (
    <div className={classNames(classes.container, {[classes.mobile]: mobile})}>
      <Dropdown
        upgrade
        mobileNativeSelect
        newErrorMessage
        className={classes.dropdown}
        data-hook={DH.MEMBERSHIP_SELECTOR}
        label="Choose membership"
        options={dropdownOptions}
        initialSelectedId={selectedPlan?.planOrderId ?? NO_MEMBERSHIP_PLAN_ORDER_ID}
        // @ts-expect-error
        errorAppearance="BackgroundAndBorder"
        onChange={selectedOption => setSelectedPlan(selectedOption.id)}
      />
    </div>
  )
}
